import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HeaderBar from '../../components/HeaderBar';
import TablePage from './TablePage';

class UnregisterRequest extends Component {
    static contextTypes = {
        clientHeight: PropTypes.number,
        notice: PropTypes.object,
    }

    constructor(props) {
        super(props);
        this.state = {
            searchParams: {},
        };
    }

    handleChange = (searchParams) => {
        this.setState({ searchParams: {...searchParams} });
    }

    render() {
        const { clientHeight, notice } = this.context;
        const { searchParams } = this.state;

        return (
            <div className="pane-item">
                <HeaderBar
                    title="请款消息"
                />
                <TablePage
                    notice={notice}
                    searchParams={searchParams}
                    clientHeight={clientHeight}
                    onChange={this.handleChange}
                />
            </div>
        );
    }
}

export default UnregisterRequest;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestInfo/RequestMessage/index.js